// src/components/Footer/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faXTwitter } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContent}>

          {/* Colonne 1: À Propos */}
          <div className={styles.footerColumn}>
            <h4 className={styles.footerTitle}>Le Poke</h4>
            <p className={styles.aboutText}>
              Découvrez des saveurs fraîches et exotiques. Des poke bowls préparés avec passion et des ingrédients de qualité.
            </p>
          </div>

          {/* Colonne 2: Liens Utiles */}
          <div className={styles.footerColumn}>
            <h4 className={styles.footerTitle}>Liens Utiles</h4>
            <ul className={styles.footerLinks}>
              {/* <-- CHANGEMENT ICI: Mise à jour des liens pour correspondre à la nouvelle navigation */}
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              
              {/* Ces liens sont déjà corrects car ils mènent à des pages distinctes */}
              <li><Link to="/mentions-legales">Mentions Légales</Link></li>
              <li><Link to="/politique-confidentialite">Politique de Confidentialité</Link></li>
            </ul>
          </div>

          {/* Colonne 3: Infos & Horaires */}
          <div className={styles.footerColumn}>
            <h4 className={styles.footerTitle}>Nous Trouver</h4>
            <div className={styles.contactInfo}>
              <p>
                15 Place du 8 Mai 1945<br />
                32200 SAMATAN
              </p>
              <p>
                Tél: <a href="tel:+33698012529">06.98.01.25.29</a>
              </p>
              <div className={styles.openingHours}>
                <p><strong>Lun-Sam:</strong> 9h-14h</p>
                <p><strong>Jeu & Ven soir:</strong> 18h-21h</p>
              </div>
            </div>
          </div>

          {/* Colonne 4: Réseaux */}
          <div className={styles.footerColumn}>
            <h4 className={styles.footerTitle}>Suivez-nous</h4>
            <div className={styles.socialIcons}>
              <a href="https://www.facebook.com/profile.php?id=100070239904930" target="_blank" rel="noopener noreferrer" aria-label="Page Facebook de Le Poke">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://www.instagram.com/lepokebyroland" target="_blank" rel="noopener noreferrer" aria-label="Page Instagram de Le Poke">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://twitter.com/lepokebyroland" target="_blank" rel="noopener noreferrer" aria-label="Compte X/Twitter de Le Poke">
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
            </div>
          </div>

        </div>

        {/* Barre inférieure pour Copyright et Propulsé par */}
        <div className={styles.footerBottom}>
          <div className={styles.copyrightSection}>
            <p className={styles.copyrightText}>
              &copy; {new Date().getFullYear()} Le Poke. Tous droits réservés.
            </p>
            <p className={styles.poweredBy}>
              Site propulsé par 
              <a href="https://www.infocolab.com/" target="_blank" rel="noopener noreferrer" className={styles.infocolabLink}>
                Infocolab
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;